export type RegistrationContextType = {
  isVerified: boolean;
  verificationMethod: string;
  hideAgeVerification: () => void;
  setVerificationMethod: (method: string) => void;
  emailField: {
    value: string;
    triggerEmailValidation: () => Promise<boolean>;
  };
  setIsVerified: (prevState: boolean) => void;
  ageVerificationUuid: string;
  setAgeVerificationUuid: (prevState: string) => void;
};

export type NewRegistrationContextType = {
  verificationMethod: string;
  setVerificationMethod: (method: string) => void;
};

export type SelectOptionType = {
  label: string;
  value: string;
  readonly?: boolean;
};

type AgeVerificationMethodFieldType = {
  code: string;
  label: string;
  hint: string;
  validation: string | null;
  type: string;
  is_required: boolean;
};

export type AgeVerificationMethodType = {
  name: string;
  isOptional?: boolean;
  code: string;
  description: string;
  priority: number | null;
  type: string;
  fields: AgeVerificationMethodFieldType[];
};

export type InitAsyncVerificationFields = {
  callback?: string;
  dateOfBirth?: string;
  firstName?: string;
  fullAddress?: string;
  identity_verification_id?: string;
  lastName?: string;
  userEmail?: string;
  vendorData?: string;
  workflowDefinitionId?: string;
  workflowName?: string;
};

export type InitAsyncVerificationPayload = {
  userEmail?: string;
  methodCode: string;
  fields?: InitAsyncVerificationFields;
  isAsync?: boolean;
};

export type AsyncAvStatuses = "success" | "pending" | "failed";

export type InitAsyncVerificationResponse = {
  uuid: string;
  verification_performed: boolean;
  status: AsyncAvStatuses;
  data: {
    session_id?: string;
    component?: string;
    token?: string;
    deeplink?: string;
    redirectUrl?: string;
    response_body?: {
      status: string;
      verification?: {
        id: string;
        url: string;
        vendorData: string;
        host: string;
        status: AsyncAvStatuses;
        sessionToken: string;
      };
    };
  };
};

export type AgeVerificationType = {
  id?: number;
  code: string;
  name: string;
  description: string;
  created_at?: string;
  updated_at?: string;
  methods: AgeVerificationMethodType[];
};

export type AvailableMethods = {
  [key: string]: AgeVerificationType;
};

export type AvailableMethodsResponse = {
  data: AgeVerificationMethodType[];
  statusCode: number;
};

export type HiddenAgeVerificationResponse = {
  has_hidden_verification: boolean;
};

export type ErrorsEntry = {
  [key: string]: string[];
};

export type AvpError = {
  message: string;
  errors: ErrorsEntry;
  error_code?: string;
};
